import type { ApiRoute, NoBody, NoPathParams, NoQueryParams } from "../api"
import type { InventoryExportView } from "../export/InventoryExportView"

export const getInventoryExportRoute: ApiRoute<NoPathParams, NoQueryParams, NoBody, InventoryExportView> = {
	buildUrl: () => "/export-inventory",
	method: "get",
	path: "/export-inventory",
}
